import { useLastNonNullRender } from "@/domains/react/useLastNonNullRender";
import {
  MDSButton,
  MDSButtonGroup,
  MDSButtonVariant,
  MDSDialog,
  MDSDialogSlotName,
  MDSDialogTextContent,
  MDSModal,
} from "@/mds";
import { MessageModal } from "@/store/modals/types";
import { MDSText, MDSTextVariant } from "@/mds";
import { observer } from "mobx-react-lite";

export interface MessageOverlayProps {
  message?: MessageModal;
}

export const MessageOverlayContent = observer<MessageOverlayProps>(function MessageOverlay({
  message,
}) {
  const content = useLastNonNullRender(() => {
    if (!message) return null;

    return (
      <MDSDialog
        isOpen={!!message}
        handleClose={() => message?.handleClose()}
        isDismissable={false}
      >
        <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
          {message.title}
        </MDSText>
        <MDSDialogTextContent slot={MDSDialogSlotName.Content}>
          <MDSText variant={MDSTextVariant.ParagraphS}>{message.message}</MDSText>
        </MDSDialogTextContent>
        <MDSButtonGroup slot={MDSDialogSlotName.ButtonsRight}>
          {message.secondaryButton && (
            <MDSButton onClick={() => message.secondaryButton?.onClick?.()}>
              {message.secondaryButton.label}
            </MDSButton>
          )}
          <MDSButton
            variant={MDSButtonVariant.Contrast}
            onClick={() => message.handleButtonClick()}
          >
            {message.buttonLabel ?? ""}
          </MDSButton>
        </MDSButtonGroup>
      </MDSDialog>
    );
  });

  return (
    <MDSModal isOpen={!!message} handleClose={() => message?.handleClose()}>
      {content}
    </MDSModal>
  );
});
